import { motion } from "framer-motion";

// Revelado al hacer scroll: usado por todas las secciones
export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 40, filter: "blur(8px)" }}
    whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

// Encabezado de sección: solo título y subtítulo
export const Chapter = ({ title, sub }) => (
  <Reveal className="mb-12 sm:mb-16">
    <div className="mb-5 h-1 w-14 rounded-full bg-gradient-to-r from-yellow-300 via-amber-400 to-amber-600 shadow-[0_0_18px_rgba(234,179,8,0.45)]" />
    <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-[-0.03em] leading-[1.08] text-slate-50 max-w-2xl">
      {title}
    </h2>
    {sub && <p className="mt-5 text-base sm:text-lg leading-relaxed text-slate-400 max-w-xl">{sub}</p>}
  </Reveal>
);
